/**
 * Formats a string using js object for replacing
 *
 * @param text string to format
 * @param replacements object to be used as params
 * @param caseSensitive whether the replacement should be case-sensitive
 * @example
 * formatObject('Hello {developer}', { developer: 'MS2 Developer' })
 */
export function formatObject(text: string, replacements: Record<string, unknown> | ArrayLike<unknown>, caseSensitive = true): string {
    let formatted = text ?? '';

    if (formatted) {
        for (const [key, value] of Object.entries(replacements)) {
            formatted = formatted.replace(new RegExp(`\\{${key}\\}`, caseSensitive ? 'gm' : 'gi'), value?.toString() ?? '');
        }
    }

    return formatted;
}
